/* eslint-disable no-console */
import React from 'react';
import VideoOverlay from '@reedexpo/video-overlay';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Row from 'react-bootstrap/lib/Row';
import StringFormatter from '../common/StringFormatter';
import ParticipantService from '../Participants/api/ParticipantService';
// eslint-disable-next-line import/no-named-as-default
import ShowPlanService from '../common/api/ShowPlanService';
import Utils from '../common/Utils';
import EventEditionService from '../common/api/EventEditionService';
import authorizationStore from '../common/api/authorizationStore';
import Product from './Product';

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideo: false,
      sourceUrl: '',
      posterUrl: '',
      videoId: '',
      isVideoEnabled: false,
      isAuthorised: false
    };
  }

  componentDidMount() {
    authorizationStore.getToken().then((token) => {
      if (token) {
        this.setState({
          isAuthorised: true
        });
      }
    });
    if (this.props.showPlanningEnabled) {
      this.getCurrentShowPlan(
        this.props.eventEditionId,
        this.props.baseApiUrl,
        Utils.getShowPlanId(this.props.eventEditionId)
      );
      window.addEventListener('pageshow', this.handlePageLoadedFromCache);
    }
    this.setVideoIconValues();
  }

  setVideoIconValues = () => {
    EventEditionService.getEventEdition(this.props.baseApiUrl, this.props.interfaceLocale, this.props.eventEditionId)
      .then((response) => {
        let isEnabledVideoicon = response.isVideoEnabled;

        if (!window.featureFilters || (window.featureFilters && this.props.eventEditionId !== window.featureFilters.eventEditionId)) {
          this.setState({ isVideoEnabled: isEnabledVideoicon });
          return;
        }
        if (response.isVideoEnabled) {
          ParticipantService.getFeatureFilters(
            this.props.baseApiUrl,
            this.props.eventEditionId,
            this.props.interfaceLocale
          ).then((res) => {
            if (!isEmpty(res.participantFeatureFilters)) {
              isEnabledVideoicon = res.participantFeatureFilters.find(ff =>
                (ff.featureFilterId === window.featureFilters.certifiedBuyerId)) !== undefined;
              this.setState({ isVideoEnabled: isEnabledVideoicon });
            } else {
              this.setState({ isVideoEnabled: false });
            }
          });
        } else {
          this.setState({ isVideoEnabled: response.isVideoEnabled });
        }
      });
  };

  getCurrentShowPlan = (eventEditionId, baseApiUrl, showPlanId) => {
    ShowPlanService.getShowPlan(
      baseApiUrl,
      eventEditionId,
      showPlanId
    ).then(serviceResult =>
      this.setState({ showPlan: serviceResult.showPlan }));
  };

  // eslint-disable-next-line no-unused-vars
  showModal = (videoSourceUrl, videoPosterUrl, productVideoId) => {
    this.toggleShowVideo();
    this.setState({
      sourceUrl: videoSourceUrl,
      posterUrl: videoPosterUrl,
      videoId: productVideoId
    });
  };

  toggleShowVideo = () => {
    this.setState({
      showVideo: !this.state.showVideo
    });
  }
  generateProducts() {
    const { products = [] } = this.props;
    return products
      .filter((product) => !product.video?.id || (product.video?.id && product.video?.status === 'Successful'))
      .map((product) => {
        return <Product
            translations={this.props.translations}
            isRounded={this.props.isRounded}
            showPlanningEnabled={this.props.showPlanningEnabled}
            getLinkURL={this.getLinkURL}
            getExhibitorDetailsUrl={this.getExhibitorDetailsUrl}
            product={product}
            isProductInShowPlan={this.isProductInShowPlan}
            isVideoEnabled={this.state.isVideoEnabled}
            isAuthorised={this.state.isAuthorised}
            showModal={this.showModal}
            showPlan={this.state.showPlan}
            updatedShowPlan={this.updatedShowPlan}
        />});
  }

  isProductInShowPlan = (productId, showPlan) => showPlan && showPlan.productIds && showPlan.productIds.includes(productId);

  handlePageLoadedFromCache = () => {
    this.getCurrentShowPlan(
      this.props.eventEditionId,
      this.props.baseApiUrl,
      Utils.getShowPlanId(this.props.eventEditionId)
    );
  };

  updatedShowPlan = (updatedShowPlan) => {
    this.setState({
      showPlan: updatedShowPlan
    });
  };

  getLinkURL = (product)=> {
    const {
      productDetailsUrlFormat, exhibitorPublicDetailsUrlFormat
    } = this.props
    let detailPageLink;
    if (productDetailsUrlFormat) {
      const environment = Utils.getCurrentEnvironment();
      if(!Utils.isDevEnvironment(environment) && !Utils.isShowEnvironment(environment) && product.name) {
        //replaces spaces with '-' from product name with meaning full name
        let productName = Utils.getSEOFriendlyName(product.name);
        detailPageLink = StringFormatter.format(productDetailsUrlFormat,
            product.exhibitingOrganisationId.concat('.', productName), product.id);
      } else {
        detailPageLink = StringFormatter.format(productDetailsUrlFormat, product.exhibitingOrganisationId, product.id);
      }
    } else {
      detailPageLink = StringFormatter.format(exhibitorPublicDetailsUrlFormat, product.organisationGuid);
    }
    return detailPageLink;
  }

  getExhibitorDetailsUrl = (product)=> {
    const {
      exhibitorPublicDetailsUrlFormat
    } = this.props
    let detailPageLink;
    const environment = Utils.getCurrentEnvironment();
    if(!Utils.isDevEnvironment(environment)  && !Utils.isShowEnvironment(environment) && product.exhibitingOrganisationName) {
      //replaces spaces with '-' from company name with meaning full name
      let exhibitorName = Utils.getSEOFriendlyName(product.exhibitingOrganisationName);
      detailPageLink = StringFormatter.format(exhibitorPublicDetailsUrlFormat, exhibitorName.concat('.', product.organisationGuid));
    }
    else{
      detailPageLink = StringFormatter.format(exhibitorPublicDetailsUrlFormat, product.organisationGuid);
    }
    return detailPageLink;
  }


  render() {
    return (
      <li style={{'--brand-color': window.reactSettingsProductsDirectory.props.themes.brandPrimary}}>
        {this.state.isVideoEnabled && this.state.isAuthorised && this.state.showVideo &&
        <VideoOverlay
          sourceUrl={this.state.sourceUrl}
          posterUrl={this.state.posterUrl}
          show={this.state.showVideo}
          onClose={this.toggleShowVideo}
          videoId={this.state.videoId}
          reactSettingsName="reactSettingsProductsDirectory"
        />}<Row>{this.generateProducts()} </Row>
      </li>);
  }
}

Products.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  hasMore: PropTypes.bool,
  refine: PropTypes.func,
  productDetailsUrlFormat: PropTypes.string.isRequired,
  exhibitorPublicDetailsUrlFormat: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  isRounded: PropTypes.bool,
  showPlanningEnabled: PropTypes.bool,
  baseApiUrl: PropTypes.string,
  interfaceLocale: PropTypes.string,
  eventEditionId: PropTypes.string
};

export default Products;
